import React from 'react';
import './InfoContact.scss';
import { Icon } from 'antd';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';

interface IProps {
  isFetching: boolean;
  isFetchFailed: boolean;
  simplified?: boolean;
  content: Julius.Website.ContactPageViewModel;
}

const InfoContact: React.SFC<IProps> = ({
  isFetching,
  isFetchFailed,
  simplified,
  content,
}) => {

  if (isFetchFailed) {
    return (
      <WrapperLayout style='info-contact'>
        <WrapperBox>
          <div className='info-content'>
            <FormattedText 
              style='info-header'
              displayName='Kontakta oss'
              formattedName='info.contact.header'
            />
            <FetchFailureMessage />
          </div>
        </WrapperBox>
      </WrapperLayout>
    );
  }

  if (isFetching || !content) {
    return null;
  }

  const { imageUrl, ...rest } = content;
  
  if (simplified) {
    return <ContactInformation { ...rest } />;
  }

  return (
    <WrapperLayout style='info-contact'>
      <div className='info-box'>
        <div className='info-content'>
        <FormattedText 
          style='info-header'
          displayName='Kontakta oss'
          formattedName='info.contact.header'
        />
        <ContactInformation { ...rest } />
        </div>
        <div 
          className='image' 
          style={ { backgroundImage: `url(${ imageUrl })` } } 
        />
      </div>
    </WrapperLayout>
  );
};

const ContactInformation: React.SFC<{
  email: string;
  adress: string;
  phoneBookings: string;
  phoneGroupBookings: string;
}> = ({
  email,
  adress,
  phoneBookings,
  phoneGroupBookings,
}) => (
  <div className='contact-information'>
    <FormattedText 
      style='contact-header bold'
      displayName='Callcenter & Biljettbokning'
      formattedName='info.contact.bookings'
    />
    <div className='contact-rows'>
      <div><Icon type='phone' />{ phoneBookings }</div>
      <div><Icon type='mail' />{ email }</div>
      <div><Icon type='home' />{ adress }</div>
    </div>
    <FormattedText 
      style='contact-header'
      displayName='Vid gruppbokning av biljetter'
      formattedName='info.contact.groupbookings'
    />
    <div className='contact-rows'>
      <div><Icon type='phone' />{ phoneGroupBookings }</div>
    </div>
  </div>
);

export default InfoContact;


// WEBPACK FOOTER //
// ./src/components/InfoContact/InfoContact.tsx